import { Component, computed, inject, signal } from '@angular/core';
import { OrganizationSidebarLayout } from '../../../organizations/components/organization-sidebar-layout/organization-sidebar-layout';
import { PageHeader } from '../../../layout/components/page-header/page-header';
import { PageTitle } from '../../../layout/components/page-title/page-title';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgIcon } from '@ng-icons/core';
import { Button } from 'excellence-ui';
import { DashboardAssistantCard } from '../../components/dashboard-assistant-card/dashboard-assistant-card';
import { DashboardConsultantCard } from '../../components/dashboard-consultant-card/dashboard-consultant-card';
import { DashboardHelpCenterCard } from '../../components/dashboard-help-center-card/dashboard-help-center-card';
import { DashboardConsumptionSummaryCard } from '../../components/dashboard-consumption-summary-card/dashboard-consumption-summary-card';
import { DashboardCostSummaryCard } from '../../components/dashboard-cost-summary-card/dashboard-cost-summary-card';
import { DashboardLocationsCard } from '../../components/dashboard-locations-card/dashboard-locations-card';
import { DashboardEnergyInterfacesCard } from '../../components/dashboard-energy-interfaces-card/dashboard-energy-interfaces-card';
import { DashboardSupplierContractsCard } from '../../components/dashboard-supplier-contracts-card/dashboard-supplier-contracts-card';
import { DashboardParseRequestAlert } from '../../components/dashboard-parse-request-alert/dashboard-parse-request-alert';
import { OrganizationsStore } from '../../../organizations/store/organizations.store';
import { FeatureEnabledDirective } from '../../../../shared/directives/feature-enabled';
import { DashboardSkeleton } from '../../components/dashboard-skeleton/dashboard-skeleton';
import { environment } from '../../../../../environments/environment';
import { ActivatedRoute } from '@angular/router';
import { DashboardHpfcPriceCard } from '../../components/dashboard-hpfc-price-card/dashboard-hpfc-price-card';

@Component({
  selector: 'app-dashboard-page',
  imports: [
    OrganizationSidebarLayout,
    PageHeader,
    PageTitle,
    TranslocoPipe,
    NgIcon,
    Button,
    DashboardAssistantCard,
    DashboardConsultantCard,
    DashboardHelpCenterCard,
    DashboardConsumptionSummaryCard,
    DashboardCostSummaryCard,
    DashboardLocationsCard,
    DashboardEnergyInterfacesCard,
    DashboardSupplierContractsCard,
    DashboardParseRequestAlert,
    FeatureEnabledDirective,
    DashboardSkeleton,
    DashboardHpfcPriceCard,
  ],
  templateUrl: './dashboard-page.html',
})
export class DashboardPage {
  private organizationsStore = inject(OrganizationsStore);
  private activatedRoute = inject(ActivatedRoute);

  protected organizationId = this.organizationsStore.selectedId;
  protected currentYear = computed(() => new Date().getFullYear());

  isAllLoading = signal(true);

  showContactDialog = computed(() => {
    return (
      !this.isAllLoading() &&
      this.activatedRoute.snapshot.queryParamMap.get('showContactDialog') === 'true'
    );
  });

  constructor() {
    setTimeout(() => {
      this.isAllLoading.set(false);
    }, environment.delays.loadFullDashboardMs);
  }
}
